import React from 'react'
import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'

const spinnerCss = css`
  display: flex;
  height: 50vh;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export default function LargeLoadingSpinner() {
  return (
    <div css={spinnerCss}>
      <NoticeLoading size="lg" />
    </div>
  )
}
